import { useEffect, useState } from 'react';

// Store timer state on globalThis to avoid memory leaks during HMR
type UseNowTimerState = {
  subscribers: Set<React.Dispatch<React.SetStateAction<number>>>;
  timer: ReturnType<typeof setInterval> | null;
};

const GLOBAL_KEY = '__useNowTimerState__';

function getGlobalState(): UseNowTimerState {
  if (!(GLOBAL_KEY in globalThis)) {
    (globalThis as any)[GLOBAL_KEY] = {
      subscribers: new Set<React.Dispatch<React.SetStateAction<number>>>(),
      timer: null,
    };
  }
  return (globalThis as any)[GLOBAL_KEY] as UseNowTimerState;
}

function startTimer() {
  const state = getGlobalState();
  if (state.timer === null) {
    state.timer = setInterval(() => {
      const now = Date.now();
      state.subscribers.forEach(cb => cb(now));
    }, 1000);
  }
}

function stopTimer() {
  const state = getGlobalState();
  if (state.timer !== null && state.subscribers.size === 0) {
    clearInterval(state.timer);
    state.timer = null;
  }
}

export function useNow(): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const state = getGlobalState();
    state.subscribers.add(setNow);
    startTimer();
    return () => {
      state.subscribers.delete(setNow);
      stopTimer();
    };
  }, []);

  return now;
}
